// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2710%27 fill=%27none%27 viewBox=%270 0 20 10%27%3E%3Cpath d=%27M6.927 1.687L0 10h20l-6.927-8.313a4 4 0 0 0-6.146 0z%27 fill=%27%23fff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2710%27 fill=%27none%27 viewBox=%270 0 20 10%27%3E%3Cpath d=%27M6.927 1.687L0 10h20l-6.927-8.313a4 4 0 0 0-6.146 0z%27 fill=%27%23111315%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xsQZeQfUSB87Fz_S9hqY {
  position: relative;
}
@media only screen and (max-width: 767px) {
  .xsQZeQfUSB87Fz_S9hqY {
    position: static;
  }
}
.xsQZeQfUSB87Fz_S9hqY.RfHEJ5TiM33NDIqVgYPJ .io3RaJIB4PxNf_RrJQ_S {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
}

.LMbinsu7d63IQNTY5IiV {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.LMbinsu7d63IQNTY5IiV img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.io3RaJIB4PxNf_RrJQ_S {
  position: absolute;
  top: calc(100% + 18px);
  right: -20px;
  width: 280px;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid transparent;
  box-shadow: 0px 40px 64px -12px rgba(0, 0, 0, 0.08), 0px 0px 14px -4px rgba(0, 0, 0, 0.05), 0px 32px 48px -8px rgba(0, 0, 0, 0.1);
  background: #FFFFFF;
  visibility: hidden;
  opacity: 0;
  transform: translateY(3px);
  transition: all 0.2s;
}
@media only screen and (max-width: 1339px) {
  .io3RaJIB4PxNf_RrJQ_S {
    top: calc(100% + 15px);
    right: 0;
    border-radius: 12px;
  }
}
@media only screen and (max-width: 767px) {
  .io3RaJIB4PxNf_RrJQ_S {
    top: 100%;
    right: 16px;
    left: 16px;
    width: auto;
    padding: 12px 16px 20px;
  }
}
.dark-mode .io3RaJIB4PxNf_RrJQ_S {
  background: #111315;
  border-color: #272B30;
}

.io3RaJIB4PxNf_RrJQ_S:before {
  content: "";
  position: absolute;
  right: 33px;
  bottom: 100%;
  width: 20px;
  height: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%/100% auto;
}
@media only screen and (max-width: 1339px) {
  .io3RaJIB4PxNf_RrJQ_S:before {
    right: 13px;
  }
}
@media only screen and (max-width: 767px) {
  .io3RaJIB4PxNf_RrJQ_S:before {
    right: 21px;
  }
}
.dark-mode .io3RaJIB4PxNf_RrJQ_S:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.sYUwZx4vF6PhNPdM6PvQ:not(:last-child) {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #EFEFEF;
}
@media only screen and (max-width: 767px) {
  .sYUwZx4vF6PhNPdM6PvQ:not(:last-child) {
    margin-bottom: 8px;
    padding-bottom: 8px;
  }
}
.dark-mode .sYUwZx4vF6PhNPdM6PvQ:not(:last-child) {
  border-color: #272B30;
}

.ufsNmxiGOcBGAyN0nKF6 {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 0 12px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
  color: #6F767E;
  transition: all 0.2s;
}
.ufsNmxiGOcBGAyN0nKF6 svg {
  margin-right: 12px;
  fill: #6F767E;
  transition: fill 0.2s;
}
.ufsNmxiGOcBGAyN0nKF6:hover, .ufsNmxiGOcBGAyN0nKF6.RfHEJ5TiM33NDIqVgYPJ {
  color: #1A1D1F;
}
.ufsNmxiGOcBGAyN0nKF6:hover svg, .ufsNmxiGOcBGAyN0nKF6.RfHEJ5TiM33NDIqVgYPJ svg {
  fill: #1A1D1F;
}
.dark-mode .ufsNmxiGOcBGAyN0nKF6:hover, .dark-mode .ufsNmxiGOcBGAyN0nKF6.RfHEJ5TiM33NDIqVgYPJ {
  color: #FCFCFC;
}
.dark-mode .ufsNmxiGOcBGAyN0nKF6:hover svg, .dark-mode .ufsNmxiGOcBGAyN0nKF6.RfHEJ5TiM33NDIqVgYPJ svg {
  fill: #FCFCFC;
}

.ufsNmxiGOcBGAyN0nKF6.RfHEJ5TiM33NDIqVgYPJ {
  background: #F4F4F4;
}
.dark-mode .ufsNmxiGOcBGAyN0nKF6.RfHEJ5TiM33NDIqVgYPJ {
  background: transparent;
}

.ufsNmxiGOcBGAyN0nKF6.qdQU73BOn30IRqdJu3Lr {
  color: #8E59FF;
}
.ufsNmxiGOcBGAyN0nKF6.qdQU73BOn30IRqdJu3Lr svg {
  fill: #8E59FF;
}
.dark-mode .ufsNmxiGOcBGAyN0nKF6.qdQU73BOn30IRqdJu3Lr {
  color: #8E59FF;
}
.dark-mode .ufsNmxiGOcBGAyN0nKF6.qdQU73BOn30IRqdJu3Lr svg {
  fill: #8E59FF;
}

.ufsNmxiGOcBGAyN0nKF6.qdQU73BOn30IRqdJu3Lr:hover {
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/User/User.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,kBAAA;AADJ;ACcI;EDdJ;IAGQ,gBAAA;EACN;AACF;AAAQ;EACI,mBAAA;EACA,UAAA;EACA,wBAAA;AAEZ;;AAAA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;AAGJ;AAFI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAIR;;AAFA;EACI,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,iIAAA;EACA,mBCQA;EDPA,kBAAA;EACA,UAAA;EACA,0BAAA;EACA,oBAAA;AAKJ;AClCI;EDgBJ;IAeQ,sBAAA;IACA,QAAA;IACA,mBAAA;EAON;AACF;AChCI;EDOJ;IAmBQ,SAAA;IACA,WAAA;IACA,UAAA;IACA,WAAA;IACA,uBAAA;EAUN;AACF;ACmIa;ED5IL,mBAAA;EACA,qBCHH;ADeL;;AAXI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,+EAAA;AAcR;AChEI;ED2CA;IASQ,WAAA;EAgBV;AACF;AC5DI;EDkCA;IAWQ,WAAA;EAmBV;AACF;AC2Ga;ED7HD,yDAAA;AAqBZ;;AAlBI;EACI,mBAAA;EACA,oBAAA;EACA,gCAAA;AAqBR;AC1EI;EDkDA;IAKQ,kBAAA;IACA,mBAAA;EAuBV;AACF;AC4Fa;EDlHD,qBC5BP;ADqDL;;AAvBA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;ECJA,eAAA;EACA,gBAAA;EACA,gBAAA;EDIA,cCxCC;EDyCD,oBAAA;AA4BJ;AA3BI;EACI,kBAAA;EACA,aC5CH;ED6CG,qBAAA;AA6BR;AA5BI;EAEI,cC7CH;AD0EL;AA5BQ;EACI,aC/CP;AD6EL;ACgEa;ED5FD,cCvDP;ADsFL;AA9BY;EACI,aCzDX;ADyFL;;AA/BI;EACI,mBC1DH;AD4FL;ACsDa;EDtFD,uBAAA;AAmCZ;;AAlCI;EACI,cCvEH;AD4GL;AApCQ;EACI,aCzEP;AD+GL;AC4Ca;EDhFD,cC3EP;ADkHL;AAtCY;EACI,aC7EX;ADqHL;;AAvCQ;EACI,YAAA;AA0CZ","sourcesContent":["@import ../../../styles/helpers\n\n.user\n    position: relative\n    +m\n        position: static\n    &.active\n        .body\n            visibility: visible\n            opacity: 1\n            transform: translateY(0)\n\n.head\n    width: 48px\n    height: 48px\n    border-radius: 50%\n    -webkit-tap-highlight-color: rgba(0,0,0,0)\n    img\n        width: 100%\n        height: 100%\n        object-fit: cover\n        border-radius: 50%\n\n.body\n    position: absolute\n    top: calc(100% + 18px)\n    right: -20px\n    width: 280px\n    padding: 16px\n    border-radius: 16px\n    border: 1px solid transparent\n    box-shadow: 0px 40px 64px -12px rgba(0, 0, 0, 0.08), 0px 0px 14px -4px rgba(0, 0, 0, 0.05), 0px 32px 48px -8px rgba(0, 0, 0, 0.1)\n    background: $n\n    visibility: hidden\n    opacity: 0\n    transform: translateY(3px)\n    transition: all .2s\n    +x\n        top: calc(100% + 15px)\n        right: 0\n        border-radius: 12px\n    +m\n        top: 100%\n        right: 16px\n        left: 16px\n        width: auto\n        padding: 12px 16px 20px\n    +dark\n        background: $n8\n        border-color: $n6\n    &:before\n        content: \"\"\n        position: absolute\n        right: 33px\n        bottom: 100%\n        width: 20px\n        height: 10px\n        background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='10' fill='none' viewBox='0 0 20 10'%3E%3Cpath d='M6.927 1.687L0 10h20l-6.927-8.313a4 4 0 0 0-6.146 0z' fill='%23fff'/%3E%3C/svg%3E\") no-repeat 50% 50% / 100% auto\n        +x\n            right: 13px\n        +m\n            right: 21px\n        +dark\n            background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='10' fill='none' viewBox='0 0 20 10'%3E%3Cpath d='M6.927 1.687L0 10h20l-6.927-8.313a4 4 0 0 0-6.146 0z' fill='%23111315'/%3E%3C/svg%3E\")\n\n.menu\n    &:not(:last-child)\n        margin-bottom: 12px\n        padding-bottom: 12px\n        border-bottom: 1px solid $n3\n        +m\n            margin-bottom: 8px\n            padding-bottom: 8px\n        +dark\n            border-color: $n6\n    \n.item\n    display: flex\n    align-items: center\n    width: 100%\n    height: 48px\n    padding: 0 12px\n    border-radius: 12px\n    +base1-s\n    color: $n4\n    transition: all .2s\n    svg\n        margin-right: 12px\n        fill: $n4\n        transition: fill .2s\n    &:hover,\n    &.active\n        color: $n7\n        svg\n            fill: $n7\n        +dark\n            color: $n1\n            svg\n                fill: $n1\n    &.active\n        background: $n2\n        +dark\n            background: transparent\n    &.color\n        color: $p4\n        svg\n            fill: $p4\n        +dark\n            color: $p4\n            svg\n                fill: $p4\n        &:hover\n            opacity: .8\n","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"user": `xsQZeQfUSB87Fz_S9hqY`,
	"active": `RfHEJ5TiM33NDIqVgYPJ`,
	"body": `io3RaJIB4PxNf_RrJQ_S`,
	"head": `LMbinsu7d63IQNTY5IiV`,
	"menu": `sYUwZx4vF6PhNPdM6PvQ`,
	"item": `ufsNmxiGOcBGAyN0nKF6`,
	"color": `qdQU73BOn30IRqdJu3Lr`
};
export default ___CSS_LOADER_EXPORT___;
